import styled, { css } from "styled-components";

import Grid from "@material-ui/core/Grid";

import colors, { transparentBg } from "core/colors";
import breakpoints from "core/breakpoints";

import { isTransparent } from "icons/ColorPicker/helpers";

export const IconEditorContainer = styled.div`
    /* all breakpoints css: */
    background: ${colors.mist};
    width: 100%;
    margin: 0 auto;

    /* tablet + desktop: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        padding: 1.5rem 0; /* 24px 0px */
        width: 30rem; /* 480px */
    }

    /* only desktop: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        width: 33.63rem; /* 538px */
    }
`;

export const IconContainer = styled.div.attrs(({ color }) => ({
    style: {
        backgroundColor: color ? color : colors.black
    }
}))`
    /* all breakpoints css: */
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ color }) =>
        isTransparent(color) &&
        css`
            z-index: 0;
            background-size: 20px;
            ${transparentBg}
        `};

    /* only mobile: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding: 3.875rem; /* 62px */
    }

    /* only tablet: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        width: 19.88rem; /* 318px */
        height: 19.88rem; /* 318px */
    }

    /* only desktop: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        width: 23.5rem; /* 376px */
        height: 23.5rem; /* 376px */
    }
`;

export const Icon = styled.div`
    background-image: ${({ backgroundImage }) => backgroundImage};
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 80%;
    height: 100%;
    max-height: 26.875rem; /* 430px */
    max-width: 26.875rem; /* 430px */
    width: 100%;
`;

export const EditingDetailsContainer = styled.div`
    /* all breakpoints css: */
    margin: 1.5rem auto 0 auto; /* 24px top margin */

    /* only mobile: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }

    /* tablet + desktop */
    @media (min-width: ${breakpoints.tablet.rem}) {
        width: 23.5rem; /* 376px */
    }
`;

export const EditingSectionTitle = styled.h6`
    color: ${colors.midnight};
    font-size: 0.6875rem;
`;

export const EditingDetailsTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    margin-bottom: 1rem; /* 16px */
`;

export const EditingDetailsBottomRow = styled(Grid)`
    height: 45px;
`;

export const IconTransformControls = styled(Grid).attrs({
    alignItems: "center",
    container: true,
    item: true,
    xs: true
})`
    & > *:not(:last-child) {
        margin-right: 1.25rem;
    }
`;

export const IconTransformControlGroup = styled.div`
    & > *:first-of-type {
        margin-right: 0.625rem;
    }
`;
